export const renderBundledDocumentViewerTopBar = () => (
  <div className="pointer-events-auto flex items-center bg-yellow-300 px-5 text-base text-yellow-900">
    We detected multiple documents bundled into one. Click between pages to change boundaries, then
    select documents to extract in the sidebar.
  </div>
)
